import { EventBadgeCodes } from 'defs/events';
import { getTargetFromFactory, TargetTypes } from 'defs/notifications';

const targets = {
	[EventBadgeCodes.B01]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B02]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B03]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B04]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B05]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B06]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B07]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B08]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B09]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B11]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B12]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B13]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B14]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B15]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B16]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B17]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B18]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B19]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B20]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B21]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B22]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B23]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B24]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B25]: {
		primary: {
			type: TargetTypes.Close,
		},
	},

	[EventBadgeCodes.B26]: {
		primary: {
			type: TargetTypes.Close,
		},
	},
};

export const get = (key: string) => getTargetFromFactory(targets, key);

export default targets;
